<div class="flex-1 h-full flex flex-col min-h-0">
  <!-- Header -->
  <div class="mt-2 h-10 shrink-0 flex items-center justify-between mb-3">
    <h1 class="headline-small md:headline-medium text-primary">{{ greeting }}, {{ userName }}</h1>
  </div>

  <div class="flex flex-col min-h-0 flex-1 gap-3 md:gap-6">
    <div class="relative flex items-center gap-3 md:gap-6 order-2 md:order-1 mt-3 md:mt-0 md:w-2/3">
      <div class="flex justify-between flex-1 items-center">
        <div class="flex translate-x-[-14px]">
          <div class="cursor-pointer flex items-center px-2 hover:bg-surface-container-low rounded-lg"
            (click)="prevDay()">
            <mat-icon class="material-symbols-outlined">chevron_left</mat-icon>
          </div>
          <div class="flex flex-col items-center text-center w-[8.5rem]">
            <span class="headline-small text-primary" data-testid="home-date-label">{{ dateLabel }}</span>
            <span class="title-small text-outline">{{ formattedDate }}</span>
          </div>
          <div class="cursor-pointer flex items-center px-2 hover:bg-surface-container-low rounded-lg"
            (click)="nextDay()">
            <mat-icon class="material-symbols-outlined">chevron_right</mat-icon>
          </div>
          @if (!isToday) {
            <button mat-icon-button (click)="setToday()" class="text-primary !w-10 !h-10 self-center" data-testid="jump-to-today-button"
              [attr.aria-label]="'Jump to today' | translate">
              <mat-icon class="material-symbols-outlined">today</mat-icon>
            </button>
          }
        </div>
      </div>
    </div>

    <div class="order-1 md:order-2 contents md:flex md:flex-row flex-1 min-h-0 md:gap-6 relative">
      <div
        class="flex-1 bg-white rounded-2xl border border-linear-stroke overflow-hidden flex flex-col min-h-0 order-3 md:order-1 w-full md:basis-2/3">
        <div class="px-1 border-b border-gray-200">
          <mat-form-field appearance="fill" class="input-borderless input-no-bottom-gap w-full">
            <mat-label>{{ 'Search your schedule' | translate }}</mat-label>
            <mat-icon svgIcon="search" matPrefix></mat-icon>
            <input [(ngModel)]="searchQuery" (ngModelChange)="onSearchCleared()" matInput data-testid="home-search-input">
          </mat-form-field>
        </div>

        <div #scheduleList class="py-2 md:p-4 flex-1 min-h-0 relative overflow-y-auto">
          @if (showLoadingSkeleton) {
          <app-appointment-skeleton variant="home" [count]="10"></app-appointment-skeleton>
          }
          @else if (filteredItems.length > 0) {
          <ul class="pl-2 pr-3 md:pr-6 md:pl-6" >
            <li *ngFor="let item of filteredItems; index as i" (click)="startEncounterFor(item, i)" [attr.data-testId]="'appointment-' + i"
              class="appointment flex px-3 md:px-4 py-3 hover:bg-gray-100 cursor-pointer rounded-lg">
              <div
                class="appointment_time w-12 text-sm/[24px] font-semibold box-content shrink-0 !tracking-[0.5px] text-primary border-r border-primary-container
                  pr-2
                  md:pr-4">
                {{ formatTime(item) }}</div>
              <div class="appointment_details pl-3 md:pl-4 flex-1 flex flex-col gap-2">
                <div class="appointment_details_name label-xlarge">{{ formatSubjectName(item) }}</div>
                <div class="label-medium font-normal text-gray-500">
                  <ng-container *ngIf="!isLegalOrg">{{ 'DOB:' | translate }} {{ formatDob(item) }}<span class="pl-2 pr-2">•</span></ng-container>{{ 'ID:' | translate }} {{ item.subject_id }}
                </div>
              </div>
              <div class="shrink-0 text-tpro-bluer flex items-center">
                <mat-icon svgIcon="dialog"></mat-icon>
              </div>
            </li>
          </ul>
          }
          @else if (isLoading) {
          <div class="h-full"></div>
          }
          @else {
          <div class="h-full">
            <div class="flex flex-col items-center justify-center h-full py-8">
              <img src="assets/folder_empty.svg" alt="" class="h-28 w-[112px] mb-6 opacity-70" />
              <div class="text-primary text-center">
                @if (!isDictateEnabled) {
                <p class="title-large">{{ 'Patient schedule not available' | translate }}</p>
                }
                @else {
                <p class="title-large">{{ 'No patients found' | translate }}</p>
                }
              </div>
            </div>
          </div>
          }
        </div>
      </div>

      <div class="space-y-4 w-full md:basis-1/3 md:pt-2 order-1 md:order-2">
        <div class="bg-white rounded-2xl">
          <h2 class="title-medium text-neutral-variant mb-4 hidden md:block">{{ 'Create documents' | translate }}</h2>
          <div class="grid grid-cols-2 gap-2">
            <button (click)="startEncounter('consultation')"
              class="flex flex-col justify-center items-center rounded-lg border border-linear-stroke hover:bg-gray-100 text-left cursor-pointer
                py-3 gap-1
                md:gap-3 md:p-4 ">
              <span class="w-10 h-10 flex justify-center items-center rounded-full bg-primary-container">
                <mat-icon svgIcon="dialog"></mat-icon>
              </span>
              <div class="text-center label-large">{{ 'Start a consultation' | translate }}</div>
            </button>
            <button (click)="startEncounter('dictation')"
              class="flex flex-col justify-center items-center rounded-lg border border-linear-stroke hover:bg-gray-100 text-left cursor-pointer
                py-3 gap-1
                md:gap-3 md:p-4">

              @if (isSmartDictationEnabled) {
                <img src="assets/smart-dictation.svg" alt="" class="w-10 h-10" />
              } @else {
                <span class="w-10 h-10 flex justify-center items-center rounded-full bg-secondary-container">
                  <mat-icon svgIcon="microphone-speaking"></mat-icon>
                </span>
              }
              <div class="text-center label-large">{{ (isSmartDictationEnabled ? 'Smart dictation' : 'Start a dictation') | translate }}</div>
            </button>
          </div>
          <div *ngIf="isUploadAudioEnabled" class="flex flex-col items-center mt-4">
            <a id="Upload_Audio" routerLink="/upload"
              class="flex items-center gap-2 text-primary hover:underline cursor-pointer py-2">
              <mat-icon svgIcon="share-ios"></mat-icon>
              <span class="label-large-prominent">{{ 'Upload audio' | translate }}</span>
            </a>
            <div class="w-full h-[0.5px] bg-surface-dim mt-2"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>